define('src/shim/jquery',[
    "jquery",
    "src/plugins/jquery.extension"
], function($) {

    // enables cross origin ressource sharing with IE9
    $.support.cors = true;

    return $;
});

